import "./styles/global.css";
import "./styles/legal.css";
import { trackEvent } from "./analytics";
import { installConsent } from "./consent";
import { mountFooter } from "./shared/footer";
import { loadAdSenseOnConsent } from "./ads/adsense";

// REN-83: /privacy and /terms were dark for the same reason the content
// surface was. Leaving two pages unmeasured would just re-create the bug.
trackEvent("visit");

const consent = installConsent();
mountFooter();
loadAdSenseOnConsent({ consent });
